// api.js

import axiosInstance from "../axiosInstance";

export const zoneChartService = {
  create: async (zoneData) => {
    try {
      let response = await axiosInstance.post("/zone-chart", {
        ...zoneData,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (client_id, searchValue, query, signal) => {
    try {
      let api_query = `/zone-chart?`;
      if (client_id) {
        api_query += `&client_id=${client_id}`;
      }

      // Add search value
      if (searchValue) api_query += `&name[$search]=${searchValue}`;
      if (query.length) api_query += `&${query}&$sort[createdAt]=-1`;
      const response = await axiosInstance.get(api_query, signal);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchZoneList: async (limit, skip, text) => {
    try {
      let response = await axiosInstance.get(
        `/zone-list?$limit=${limit || 15}&$skip=${skip || 0}${
          text ? `&search=${text}` : ""
        }`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchZipcodeList: async (limit, skip, text) => {
    try {
      let response = await axiosInstance.get(
        `/zipcode-list?$limit=${limit || 15}&$skip=${skip || 0}&${
          text ? `search=${text}` : ""
        }`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (zoneData, id) => {
    try {
      let response = await axiosInstance.patch(`/zone-chart/${id}`, {
        ...zoneData,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/zone-chart/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  syncZoneChart: async () => {
    try {
      let response = await axiosInstance.get(`/pull-zone-chart`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchConfig: async () => {
    try {
      let response = await axiosInstance.get(`/zone-chart-config`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
